import { Modal } from "react-bootstrap";

// Modale ad altezza viewport: il contenuto gestisce lo scorrimento dei pannelli.
export default function WorkspaceModal({ show, onClose, title, footer, children, size = "xxl", className = "", busy = false, compact = false }) {
  return <Modal show={show} onHide={onClose} backdrop="static" centered
    size={size === "xxl" ? "xl" : size}
    keyboard={!busy}
    className={`gull-workspace-modal ${size === "xxl" ? "gull-workspace-wide" : ""} ${compact ? "gull-workspace-compact" : ""} ${className}`}>
    <Modal.Header closeButton={!busy}><Modal.Title as="div">{title}</Modal.Title></Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    {footer && <Modal.Footer>{footer}</Modal.Footer>}
  </Modal>;
}
